import { useState, useEffect, React, useReducer } from 'react'
import { initialstate, myreducer, fetchbygetmethod, fetchbyputmethod, fetchbypostmethod } from '../Commonfiles/Myreducer';
import Spinner from '../Commonfiles/spinner';
import Nodatafound from '../Commonfiles/nodatafound';
import axios from 'axios';
import { Gotohome } from '../Commonfiles/checkfortoken';
import { editableInputTypes } from '@testing-library/user-event/dist/utils';
//import { get } from 'http';

function DscommunicationDetails() {
	

	const[updatedata,setupdatedata]= useReducer(myreducer, initialstate);
	const [mydata, setmydata] = useReducer(myreducer, initialstate);
	  const [getcountry, setgetcountry] = useState(null);
		  const [getcity, setgetcity] = useState(null);
		  const [getstate, setgetstate] = useState(null);
		  const [getarea, setgetarea] = useState(null);
			 const [selectedStateId, setSelectedStateId] = useState(null);
	         const [localGetCity, setLocalGetCity] = useState(getcity || []);
			 const [localGetArea, setLocalGetArea] = useState(getarea || []);
			 const [selectedCityId, setSelectedCityId] = useState(null);
			 const [selectedAreaId, setSelectedAreaId] = useState(null);



			 
		  
	
	async function loaddata() {

		fetchbygetmethod(setmydata, 'communicationdetail', { tempid: sessionStorage.getItem("tempID") });//,old:old.value,nyu:nyu.value});//, month: month, year: year })
	} 


	
	async function updatcommedata() {

		var CountryId=document.getElementById('CountryId').value;
		var StateId=document.getElementById('StateId').value;
		var CityId=document.getElementById('CityId').value;
		var AreaId=document.getElementById('AreaId').value;
		var HouseNo=document.getElementById('HouseNo').value;
		var MobileNo=document.getElementById('MobileNo').value;
		var Email=document.getElementById('Email').value;

		

		fetchbyputmethod(setupdatedata, 'updateCommunicationdetails', { tempid: sessionStorage.getItem("tempID"),
			CountryId: CountryId,
			StateId: StateId,
			CityId: CityId,
			AreaId: AreaId,
			HouseNo: HouseNo,
			MobileNo: MobileNo ,
			Email,Email});


			console.log(updatedata);
			
			alert("Successfully updated Communication details!");
		
		//,old:old.value,nyu:nyu.value});//, month: month, year: year })
	} 

	async function Getcountryname() {
        await fetch(process.env.REACT_APP_URL + "getcountryname", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetcountry(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
      }



      async function Getstatesname() {
        await fetch(process.env.REACT_APP_URL + "getstatesname", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetstate(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    
      async function Getcityname(StateId) {
        if (!StateId) {
          console.log("Invalid state ID:", StateId);
          return; // Don't make the request if the stateid is invalid
        }
    
        await fetch(process.env.REACT_APP_URL + "getcityname?stateid=" + StateId, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetcity(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
    
        //alert("Selected State ID: " + stateid);
      }


      async function Getareaname(Cityid) {
        if (!Cityid) {
          console.log("Invalid Area ID:", Cityid);
          return; // Don't make the request if the stateid is invalid
        }
    
        await fetch(process.env.REACT_APP_URL + "getareaname?Cityid=" + Cityid, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetarea(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
    
        //alert("Selected State ID: " + stateid);
      }

	useEffect(() => { loaddata() }, []) ;
	useEffect(() => {
			Getcountryname(); // Call the function here
		  }, []);
		
		  useEffect(() => {
			Getstatesname(); // Call the function here
		  }, []);
		
		  useEffect(() => {
			Getcityname(); // Call the function here
		  }, []);
	
		  useEffect(() => {
			Getareaname(); // Call the function here
		  }, []);

		  useEffect(() => {
			if (selectedStateId) {
			  console.log("Fetching cities for StateId:", selectedStateId);
			  Getcityname(selectedStateId);
			  setSelectedCityId(""); // Reset city when state changes
			  setLocalGetArea([]); // Reset areas when state changes
			}
		  }, [selectedStateId]);
		
		  useEffect(() => {
			if (Array.isArray(getcity)) {
			  console.log("City list updated:", getcity);
			  setLocalGetCity(getcity.length > 0 ? getcity : []);
			}
		  }, [getcity]);
		
		  useEffect(() => {
			if (selectedCityId) {
			  console.log("Fetching areas for CityId:", selectedCityId);
			  Getareaname(selectedCityId);
			  setSelectedAreaId(""); // Reset area when city changes
			}
		  }, [selectedCityId]);
		
		  useEffect(() => {
			if (Array.isArray(getarea)) {
			  console.log("Area list updated:", getarea);
			  setLocalGetArea(getarea.length > 0 ? getarea : []);
			}
		  }, [getarea]);
	return (
		<div class="content-page">
			<div class="content">
				<div class="">
					<div class="page-header-title">
						<h4 class="page-title">Update Profile</h4>

					</div>
				</div>

				<div class="page-content-wrapper ">
					<div class="container">
						{mydata.initialstage == true ? <></> : mydata.myloading == true ? <Spinner />
							: mydata.myerror == true ? <Nodatafound />
								:
								  
									
										<div class="row">
											<div class="col-sm-12">
												<div class="panel panel-primary">
													<div class="panel-body">
														<h4 class="m-t-0 m-b-30">Communication Details</h4>
														<hr width="100%" />
														<div class="row">
															<div class="col-sm-6 col-xs-12">

																<div class="m-t-20">
																	<form class="" action="#">
																		<div class="form-group">
																			<label>Country</label>
																			{mydata.mypost.length > 0 && mydata.mypost[0].CountryName ? (
  <input
    type="text"
    className="form-control"
    readOnly
    defaultValue={mydata.mypost[0].CountryName}
  />
) : (
	<select
    className="form-control"
    id="CountryId"
    defaultValue={mydata.mypost.Countryid || ""}
    onChange={(e) => {
        console.log("Selected Country ID:", e.target.value);
    }}
>
<option defaultValue={mydata.mypost.CountryName || "Select Country"} hidden>
        {mydata.mypost.CountryName || "Select Country"}
    </option>
    {Array.isArray(getcountry) && getcountry.length > 0 ? (
        getcountry.map((country) => (
            <option key={country.Countryid} value={country.Countryid}>
                {country.CountryName}
            </option>
        ))
    ) : (
        <option disabled>Loading countries...</option>
    )}
</select>
)}


																		</div>
																		<div class="form-group">
																			<label>City</label>
																			{mydata.mypost.length > 0 && mydata.mypost[0].Cityname ? (
  <input
    type="text"
    className="form-control"
    readOnly
    defaultValue={mydata.mypost[0].Cityname}
  />
) : (
  <select
    className="form-control"
    id="CityId"
    value={selectedCityId}
    onChange={(e) => setSelectedCityId(e.target.value)}
    disabled={!selectedStateId || localGetCity.length === 0}
  >
    <option value="" hidden>Select City</option>
    {localGetCity.length > 0 ? (
      localGetCity.map((city) => (
        <option key={city.CityId} value={city.CityId}>
          {city.CityName}
        </option>
      ))
    ) : (
      <option disabled>No cities available</option>
    )}
  </select>
)}


																		</div>
																		<div class="form-group">
																			<label>House No.</label>
																			<input type='text'
																				class="form-control"
																				id='HouseNo'
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].HouseNo!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].HouseNo:''}
																			/>
																			
																		</div>
																		<div class="form-group">
																			<label>Mobile No.</label>
																			<input type='text'
																				class="form-control"
																				id='MobileNo'
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].MobileNo!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].MobileNo:''}
																			/>
																			
																		</div>
																		
																	</form>
																</div>
															</div>
															<div class="col-sm-6 col-xs-12">

																<div class="m-t-20">
																	<form action="#">
																		<div class="form-group">
																			<label>State</label>
																			{mydata.mypost.length > 0 && mydata.mypost[0].StateName ? (
  <input
    type="text"
    className="form-control"
    readOnly
    defaultValue={mydata.mypost[0].StateName}
  />
) : (
  <select
    className="form-control"
    id="StateId"
    value={selectedStateId}
    onChange={(e) => setSelectedStateId(e.target.value)}
  >
    <option value="" hidden>Select State</option>
    {Array.isArray(getstate) && getstate.length > 0 ? (
      getstate.map((state) => (
        <option key={state.StateId} value={state.StateId}>
          {state.StateName}
        </option>
      ))
    ) : (
      <option disabled>Loading States...</option>
    )}
  </select>
)}

																		</div>
																		<div class="form-group">
																			<label>Area</label>
																			{mydata.mypost.length > 0 && mydata.mypost[0].areaname ? (
  <input
    type="text"
    className="form-control"
    readOnly
    defaultValue={mydata.mypost[0].areaname}
  />
) : (
  <select
    className="form-control"
    id="AreaId"
    value={selectedAreaId}
    onChange={(e) => setSelectedAreaId(e.target.value)}
    disabled={!selectedCityId || localGetArea.length === 0}
  >
    <option value="" hidden>Select Area</option>
    {Array.isArray(localGetArea) && localGetArea.length > 0 ? (
      localGetArea.map((area) => (
        <option key={area.AreaId} value={area.AreaId}>
          {area.AreaName}
        </option>
      ))
    ) : (
      <option disabled>No areas available</option>
    )}
  </select>
)}

                                                                 
																		</div>
																		<div class="form-group">
																			<label>Email</label>
																			<input type='text'
																				class="form-control"
																				id='Email'
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].Email!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].Email:''}
																			/>
																			
																		</div>


																		<div class="form-group">
																			<label>Phone No. Phone no with STD code.</label>
																			<input type='text'
																				class="form-control"
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].PhoneNo!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].PhoneNo:''}
																			/>
																			
																		</div>
																		{/* <div class="form-group">
																			<label>ID Proof Type</label>
																			<div>
																				<input type="text" class="form-control" required
																					data-parsley-min="6" placeholder="Min value is 6" 
																					readOnly={mydata.mypost.length > 0 && mydata.mypost[0].IdProof!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].IdProof:''}
																			/>
																			</div>
																		</div> */}
																		{/* <div class="form-group">
																			<label>Adhar Back Image</label>

																			<div>
																				<input type="file" class="form-control" onChange={handleFileChangeforIdproof}
																				/>
																			</div>
																			<div>
																				<img style={{ height: 300, width: 300 }}
																					src={fileIdproofimage ? fileIdproofimage : Array.isArray(mydata.mypost) && mydata.mypost.length > 0 && mydata.mypost[0].IdProof ? './uploads/' + mydata.mypost[0].IdProof : process.env.PUBLIC_URL + imagedefault} alt=""
																					className="img-circle" />

																			</div>
																		</div>
																		<div class="form-group">
																			<div>
																				<button type="submit" onClick={(e) => onSubmitIdproof(e)}
																					class="btn btn-primary waves-effect waves-light">
																					Submit Id Proof</button>


																			</div>
																		</div> */}
																		
																	</form>

																	<div className="form-group">


<div>

    <button type="submit"
        className="btn btn-primary waves-effect waves-light" style={{ marginLeft: 300 }} onClick={updatcommedata}>
        Update</button>

</div>




</div>
                                   




																</div>

															</div>


														</div>
													</div>
												</div>
											</div>
										</div>
									
								
						}
					</div>
				</div>
			</div>
			<Gotohome mydata={mydata} />
		</div>
	)
}

export default DscommunicationDetails;